import type { BodyRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { PollContentObjectDetailDataObject } from 'models/service';

type CreatePollRequest = { poll: Record<string, unknown> };

export const createPoll = async ({ body }: BodyRequest<CreatePollRequest>) =>
  apiClient.post<PollContentObjectDetailDataObject, ApiClientResponse<PollContentObjectDetailDataObject>>(
    routes.polls.create,
    body,
  );
